import React from 'react';
interface BrowserMockupProps {
  image: string;
  alt: string;
  className?: string;
  viewportAspect?: string;
  revealOnHover?: boolean;
}
export function BrowserMockup({
  image,
  alt,
  className = '',
  viewportAspect = 'aspect-[16/10]',
  revealOnHover = false
}: BrowserMockupProps) {
  return <div className={`overflow-hidden rounded-card border border-hairline bg-[#F6F6F4] p-2 shadow-[0_16px_40px_rgba(14,14,14,0.10)] ${className}`} data-id="element-432" data-mp="13qyi3g0c1ahu">
      <div className="flex h-8 items-center gap-1.5 border-b border-hairline px-2.5" data-id="element-433" data-mp="pu1t7k3ry33l">
        <span className="h-1.5 w-1.5 rounded-full bg-[#BDBDB8]" data-id="element-434" data-mp="usmqpbrn68oc" />
        <span className="h-1.5 w-1.5 rounded-full bg-[#BDBDB8]" data-id="element-435" data-mp="gs2cyu0l331p" />
        <span className="h-1.5 w-1.5 rounded-full bg-[#BDBDB8]" data-id="element-436" data-mp="ksvyxhugu7ry" />
        <span className="ml-3 h-3 flex-1 rounded-full bg-white" data-id="element-437" data-mp="kt5q38r8ykz8" />
      </div>
      <div className={`relative mt-2 overflow-hidden bg-white ${viewportAspect}`} data-id="element-438" data-mp="2b6cwqo2bn70m">
        <img src={image} alt={alt} loading="lazy" decoding="async" className={`absolute inset-x-0 top-0 w-full object-cover object-top ${revealOnHover ? 'transition-transform duration-[3000ms] ease-out group-hover:-translate-y-[58%] group-focus-visible:-translate-y-[58%]' : ''}`} data-id="element-439" data-mp="2f76ndp75ezx7" />
      </div>
    </div>;
}